import CatLoader from '../components/CatLoader';
import { useState, useRef } from 'react';
import api from '../api';
import { usePageState } from '../hooks/usePageState';

function UploadTab({ title, description, format, endpoint, onSuccess, accept='.xlsx', maxMb=50 }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const inputRef = useRef();

  const handleFile = (e) => { const f=e.target.files[0]; if(f){setFile(f);setResult(null);setError(null);} };
  const handleDrop = (e) => {
    e.preventDefault();
    const f=e.dataTransfer.files[0];
    if(f&&f.name.endsWith('.xlsx')){setFile(f);setResult(null);setError(null);}
  };
  const handleImport = async () => {
    if (!file) return;
    setLoading(true); setError(null); setResult(null);
    try {
      const form = new FormData();
      form.append('file', file);
      const r = await api.post(endpoint, form, {
        headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000,
      });
      setResult(r.data);
      if (onSuccess) onSuccess();
    } catch(e) { setError(e.response?.data?.error || e.message); }
    finally { setLoading(false); }
  };

  return (
    <>
      <CatLoader loading={loading}/>
      <div style={{maxWidth:680}}>
      <div style={{marginBottom:20}}>
        <div style={{fontSize:16,fontWeight:700,color:'var(--text)'}}>{title}</div>
        <div style={{fontSize:12,color:'var(--text-muted)',marginTop:4}}>{description}</div>
      </div>
      <div onDrop={handleDrop} onDragOver={e=>e.preventDefault()}
        onClick={()=>inputRef.current?.click()}
        style={{border:`2px dashed ${file?'var(--accent)':'var(--border)'}`,borderRadius:12,
          padding:32,textAlign:'center',cursor:'pointer',marginBottom:16,
          background:file?'rgba(59,130,246,0.05)':'var(--surface)',transition:'all 0.2s'}}>
        <input ref={inputRef} type="file" accept={accept} onChange={handleFile} style={{display:'none'}}/>
        <div style={{fontSize:32,marginBottom:8}}>📊</div>
        {file ? (
          <>
            <div style={{fontSize:13,fontWeight:600,color:'var(--accent)'}}>{file.name}</div>
            <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>{(file.size/1024/1024).toFixed(1)} МБ</div>
          </>
        ) : (
          <>
            <div style={{fontSize:13,fontWeight:600}}>Перетащите файл или нажмите для выбора</div>
            <div style={{fontSize:11,color:'var(--text-muted)',marginTop:4}}>Только .xlsx, до {maxMb} МБ</div>
          </>
        )}
      </div>
      {format&&(
        <div style={{padding:14,background:'rgba(59,130,246,0.05)',border:'1px solid rgba(59,130,246,0.15)',
          borderRadius:10,marginBottom:16,fontSize:12,color:'var(--text-muted)',lineHeight:1.7}}>
          <div style={{fontWeight:600,marginBottom:6,color:'var(--text)'}}>📋 Формат файла</div>
          {format}
        </div>
      )}
      <button onClick={handleImport} disabled={!file||loading} style={{
        padding:'9px 22px',fontSize:13,fontWeight:600,borderRadius:8,border:'none',
        cursor:!file||loading?'not-allowed':'pointer',
        background:!file||loading?'var(--border)':'var(--accent)',
        color:!file||loading?'var(--text-muted)':'#fff',
      }}>{loading?'⟳ Загружаем...':'↑ Загрузить и импортировать'}</button>
      {loading&&<div style={{marginTop:12,fontSize:12,color:'var(--text-muted)'}}>Обрабатываем файл...</div>}
      {error&&(
        <div style={{marginTop:14,padding:12,background:'rgba(239,68,68,0.1)',
          border:'1px solid rgba(239,68,68,0.3)',borderRadius:8,color:'var(--red)',fontSize:13}}>
          Ошибка: {error}
        </div>
      )}
      {result&&(
        <div style={{marginTop:14,padding:14,background:'rgba(16,185,129,0.1)',
          border:'1px solid rgba(16,185,129,0.3)',borderRadius:8}}>
          <div style={{fontSize:14,fontWeight:700,color:'var(--green)',marginBottom:6}}>✓ Импорт завершён</div>
          <div style={{fontSize:13,color:'var(--text)',lineHeight:1.8}}>
            {result.message}<br/>
            {result.imported!=null&&<>Записей: <b>{result.imported}</b><br/></>}
            {result.updated!=null&&<>Артикулов: <b>{result.updated}</b><br/></>}
            {result.skipped>0&&<>Пропущено: <b>{result.skipped}</b><br/></>}
          </div>
        </div>
      )}
    </div>
    </>
  );
}

const TABS = [

  { id:'ff-stock', label:'🏭 ФФ остатки', title:'Остатки на складе ФФ',
    description:'Загрузите файл с реальными остатками на складе фулфилмента. Минусовые остатки считаются как 0.',
    endpoint:'/import/ff-stock',
    format:<>• Колонка A — nmId WB (артикул)<br/>• Колонка B — баркод<br/>• Колонка C — реальный остаток ФФ (минус = 0)</> },
{ id:'china', label:'🚢 Китай в пути', title:'Китай в пути',
    description:'Загрузите файл с товарами в пути из Китая. Формат: колонка A — артикул, колонка B — размеры (S=155 M=125 L=90).',
    endpoint:'/import/china',
    format:<>• Колонка A — артикул продавца<br/>• Колонка B — размеры и количество (например: S=155 M=125 L=90)</> },
  { id:'other', label:'📂 Другие', title:'Другие данные', description:'Скоро...', endpoint:'/import/other', format:null, disabled:true },
];

export default function Import() {
  const [activeTab, setActiveTab] = useState('orders');
  const { clear } = usePageState('monitoring');
  const tab = TABS.find(t=>t.id===activeTab);

  return (
    <div style={{padding:28,color:'var(--text)'}}>
      <div style={{fontSize:20,fontWeight:700,marginBottom:20}}>Импорт данных</div>
      <div style={{display:'flex',gap:6,marginBottom:28,borderBottom:'1px solid var(--border)'}}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>!t.disabled&&setActiveTab(t.id)}
            style={{padding:'8px 16px',fontSize:13,fontWeight:600,borderRadius:'8px 8px 0 0',
              border:'1px solid var(--border)',borderBottom:'none',cursor:t.disabled?'not-allowed':'pointer',
              background:activeTab===t.id?'var(--surface)':'transparent',
              color:t.disabled?'var(--border)':activeTab===t.id?'var(--text)':'var(--text-muted)',
              marginBottom:-1}}>{t.label}</button>
        ))}
      </div>
      {tab&&!tab.disabled&&(
        <UploadTab key={tab.id} title={tab.title} description={tab.description}
          format={tab.format} endpoint={tab.endpoint} onSuccess={clear}/>
      )}
      {tab?.disabled&&(
        <div style={{color:'var(--text-muted)',fontSize:14,padding:32,textAlign:'center'}}>🚧 Раздел в разработке</div>
      )}
    </div>
  );
}